const CheckboxLight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2ZM12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM18.25 8.891L16.829 7.482L10.724 13.7L7.646 10.763L6.25 12.199L10.75 16.518L18.25 8.891Z"
      fill="#4EA699"
    />
  </svg>
)

export default CheckboxLight
